var Enum = Enum || {};

Enum.USER_TYPE = {
	ADMIN: 'ADMIN',
	DOCTOR: 'DOCTOR',
	OFFICE: 'OFFICE',
	HELP_DESK: 'HELP_DESK',
	MEDICAL_OFFICE: 'MEDICAL_OFFICE'
};

Object.freeze(Enum.USER_TYPE);